'use strict';
require('../../../modules/es.array.reduce-right');
var getBuiltInPrototypeMethod = require('../../../internals/get-built-in-prototype-method');

module.exports = getBuiltInPrototypeMethod('Array', 'reduceRight');
